/**
 * MatchHubSuggestionChip - suggest+confirm name reconciliation (ADR-005 P4b).
 *
 * Renders only when a Person has a pending MatchHub name suggestion. Confirm
 * applies the suggested name locally (and writes back to MatchHub if the editor
 * later diverges); Dismiss records the "no". Self-hides after either action —
 * the persisted name reflects on the next photo reload. Never auto-applies.
 */

import { useState } from 'react';
import { confirmMatchHubName, dismissMatchHubSuggestion } from '../../../../api';
import styles from './MatchHubSuggestionChip.module.css';

export default function MatchHubSuggestionChip({ person }) {
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const suggested = person.matchhub_suggested_name;
  if (done || person.matchhub_suggestion_state !== 'pending' || !suggested) return null;

  const current =
    person.display_name || `${person.first_name || ''} ${person.last_name || ''}`.trim();

  const act = async (fn) => {
    setBusy(true);
    try {
      await fn();
      setDone(true);
    } catch (err) {
      console.error('MatchHub suggestion action failed:', err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.chip}>
      <span className={styles.from}>{current || '—'}</span>
      <span className={styles.arrow}>&rarr;</span>
      <span className={styles.to} title="MatchHub suggestion">
        {suggested}
      </span>
      <button
        className={styles.confirm}
        disabled={busy}
        onClick={() => act(() => confirmMatchHubName('persons', person.id))}
      >
        Confirm
      </button>
      <button
        className={styles.dismiss}
        disabled={busy}
        onClick={() => act(() => dismissMatchHubSuggestion('persons', person.id))}
      >
        Dismiss
      </button>
    </div>
  );
}
